import { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { Alert } from 'reactstrap'
import { gql } from '@apollo/client'
import { handleGraphQLErrors } from '../../utils.js'
import Spinner from '../Spinner/Spinner.js'
import { REBUILD_SCHEMA_TABLE_MUTATION } from '../../graphql.js'

export const REBUILD_SCHEMA_TABLE = gql(REBUILD_SCHEMA_TABLE_MUTATION)

export default function RebuildSchemaTable(props) {
  console.log('RebuildSchemaTable rendered: ', props)

  const [showSpinner, setShowSpinner] = useState(false)
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function executeMutation() {
      console.log('RebuildSchemaTable.useEffect.fetchReport')
      try {
        setShowSpinner(true)
        const { errors } = await window.apolloClient.mutate({ mutation: REBUILD_SCHEMA_TABLE })
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    if (graphQLErrors.length === 0) {
      executeMutation()
    }
  }, [graphQLErrors])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else {
    return <Navigate to='/tools/schemas' replace={true} />
  }
}
